import RSAA from 'redux-api-middleware/lib/RSAA';
import {
	createEWOutcomeRequest,
	createAdditionalPaymentGuidanceRequest,
	createGenerateRetrievalIdRequest,
	createOutcomeAcknowledgementRequest,
} from '../utils/requestBuilder';
import {
	continueApproverJourney,
	// getApiError,
	getCommonData,
	getCustomerType,
	getEWIDs,
	isApprovalJourney,
	isSMEUser,
	isStaticWarning,
} from './selectors';
import endpoints from '../../utils/endpoints';
import { getUserId } from '../../states/user/selectors';
import { isBatch, getBatchId } from '../../states/batch/selectors';
import { goToPage, pages } from '../../states/page/actions';
import capitalize from 'lodash/capitalize';

export const GET_PAYMENT_REASON_REQUEST = 'GET_PAYMENT_REASON_REQUEST';
export const GET_PAYMENT_REASON_SUCCESS = 'GET_PAYMENT_REASON_SUCCESS';
export const GET_PAYMENT_REASON_FAILURE = 'GET_PAYMENT_REASON_FAILURE';
export const CREATE_OUTCOME_REQUEST = 'CREATE_OUTCOME_REQUEST';
export const CREATE_OUTCOME_SUCCESS = 'CREATE_OUTCOME_SUCCESS';
export const CREATE_OUTCOME_FAILURE = 'CREATE_OUTCOME_FAILURE';
export const RETRIEVE_OUTCOME_REQUEST = 'RETRIEVE_OUTCOME_REQUEST';
export const RETRIEVE_OUTCOME_SUCCESS = 'RETRIEVE_OUTCOME_SUCCESS';
export const RETRIEVE_OUTCOME_FAILURE = 'RETRIEVE_OUTCOME_FAILURE';
export const UPDATE_OUTCOME_ACK_REQUEST = 'UPDATE_OUTCOME_ACK_REQUEST';
export const UPDATE_OUTCOME_ACK_SUCCESS = 'UPDATE_OUTCOME_ACK_SUCCESS';
export const UPDATE_OUTCOME_ACK_FAILURE = 'UPDATE_OUTCOME_ACK_FAILURE';
export const RESET_EFFECTIVE_WARNING = 'RESET_EFFECTIVE_WARNING';
export const SET_DECLARATION_STATUS = 'SET_DECLARATION_STATUS';
export const SET_UI_ERROR = 'SET_UI_ERROR';
export const SET_ANSWER_ID = 'SET_ANSWER_ID';
export const UPDATE_REASON = 'UPDATE_REASON';
export const SET_CURRENT_WARNING_PAGE = 'SET_CURRENT_WARNING_PAGE';
export const SET_ACCOUNT_DETAILS_PAYEE_ID = 'SET_ACCOUNT_DETAILS_PAYEE_ID';

export const UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_REQUEST = 'UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_REQUEST';
export const UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_SUCCESS = 'UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_SUCCESS';
export const UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_FAILURE = 'UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_FAILURE';

export const GENERATE_RETRIEVAL_ID_REQUEST = 'GENERATE_RETRIEVAL_ID_REQUEST';
export const GENERATE_RETRIEVAL_ID_SUCCESS = 'GENERATE_RETRIEVAL_ID_SUCCESS';
export const GENERATE_RETRIEVAL_ID_FAILURE = 'GENERATE_RETRIEVAL_ID_FAILURE';

export const CANCEL_PAYMENT_REQUEST = 'CANCEL_PAYMENT_REQUEST';
export const CANCEL_PAYMENT_SUCCESS = 'CANCEL_PAYMENT_SUCCESS';
export const CANCEL_PAYMENT_FAILURE = 'CANCEL_PAYMENT_FAILURE';

export const RESET_APP = 'RESET_APP';

export const resetEffectiveWarning = () => ({ type: RESET_EFFECTIVE_WARNING });

export const updateReason = (id, reason) => ({
	type: UPDATE_REASON,
	id,
	reason,
});

export const setDeclarationStatus = (declarationValue) => ({
	type: SET_DECLARATION_STATUS,
	declarationValue,
});

export const setUIError = (uiError) => ({
	type: SET_UI_ERROR,
	uiError,
});

export const setCurrentWarningPage = (currentPage) => ({
	type: SET_CURRENT_WARNING_PAGE,
	currentPage,
});

export const setAccountDetailsPayeeId = (id) => ({
	type: SET_ACCOUNT_DETAILS_PAYEE_ID,
	payload: id,
});

export const cancelPayment = () => (dispatch, getState) => {
	const { effectiveWarningId } = getCommonData(getState());
	const { x_bpi_version, method } = endpoints.cancelPayment;
	const urlData = {
		scopeId: 'default',
		effectiveWarningId,
	};
	const endpoint = endpoints.cancelPayment.resolve(urlData);
	const body = { status: 'CANCELLED' };
	const action = {
		[RSAA]: {
			endpoint,
			method,
			body: JSON.stringify(body),
			types: [CANCEL_PAYMENT_REQUEST, CANCEL_PAYMENT_SUCCESS, CANCEL_PAYMENT_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};

	return dispatch(action);
};

export const getPaymentReasons = () => (dispatch, getState) => {
	const state = getState();
	const { x_bpi_version, method } = endpoints.getPaymentReasons;
	const urlData = {
		scopeId: 'default',
		customerType: capitalize(getCustomerType(state)),
	};
	const endpoint = endpoints.getPaymentReasons.resolve(urlData);
	const action = {
		[RSAA]: {
			endpoint,
			method,
			types: [GET_PAYMENT_REASON_REQUEST, GET_PAYMENT_REASON_SUCCESS, GET_PAYMENT_REASON_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};

	return dispatch(action);
};

export const createEWOutcome =
	(payType = null) =>
	(dispatch, getState) => {
		const state = getState();
		const {
			reasonId,
			reason,
			userId,
			effectiveWarningId,
			customerType,
			accountDetails,
			paymentAmount,
			paymentDetails,
			isStatic,
		} = getCommonData(state, payType);
		const endpoint = isStatic ? endpoints.createEWOutcomeStatic : endpoints.createEWOutcome;
		const { x_bpi_version, method, uri } = endpoint;

		const data = {
			paymentAmount,
			userId,
			reasonId,
			reason,
			customerType: capitalize(customerType),
			effectiveWarningId,
			isStaticWarning: isStatic,
			accountDetails,
			paymentDetails,
			isBatch: isBatch(state),
			batchId: getBatchId(state),
		};
		const body = createEWOutcomeRequest(data);
		const action = {
			[RSAA]: {
				endpoint: uri,
				method,
				body,
				types: [CREATE_OUTCOME_REQUEST, CREATE_OUTCOME_SUCCESS, CREATE_OUTCOME_FAILURE],
				headers: { 'x-bpi-version': x_bpi_version },
			},
		};

		return dispatch(action);
	};

export const generateRetrievalId = () => (dispatch, getState) => {
	const state = getState();
	const { x_bpi_version, method } = endpoints.generateRetrievalId;

	const endpoint = endpoints.generateRetrievalId.resolve('default');
	const warningIds = getEWIDs(state);
	const userId = getUserId(state);

	const body = createGenerateRetrievalIdRequest({
		warningIds,
		userId,
	});

	const action = {
		[RSAA]: {
			endpoint,
			method,
			body,
			types: [GENERATE_RETRIEVAL_ID_REQUEST, GENERATE_RETRIEVAL_ID_SUCCESS, GENERATE_RETRIEVAL_ID_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};

	return dispatch(action);
};

export const retrieveEWOutcome =
	({ payType }) =>
	(dispatch, getState) => {
		const state = getState();

		const {
			accountDetails: fromAccount,
			userId,
			effectiveWarningId,
			journey,
			retrievalId,
			isStatic,
		} = getCommonData(state, payType);
		const { x_bpi_version, method } = endpoints.retrieveEWOutcome;
		const ewID = isStatic ? retrievalId : effectiveWarningId;
		const multipleApproval = isStatic ? 'T' : 'F';

		const urlData = {
			scopeId: 'default',
			effectiveWarningId: ewID,
			journey,
			sortCode: fromAccount.sort_code,
			accountNumber: fromAccount.account_number,
			accountId: fromAccount.id,
			customerId: userId,
			isMultipleApproval: multipleApproval,
		};

		const endpoint = endpoints.retrieveEWOutcome.resolve(urlData);
		const action = {
			[RSAA]: {
				endpoint,
				method,
				types: [RETRIEVE_OUTCOME_REQUEST, RETRIEVE_OUTCOME_SUCCESS, RETRIEVE_OUTCOME_FAILURE],
				headers: { 'x-bpi-version': x_bpi_version },
			},
		};

		return dispatch(action);
	};

const getEWOutcome = (getState, dispatch, onContinue, payType) =>
	dispatch(retrieveEWOutcome({ payType })).then(() => {
		const state = getState();
		// if (getApiError(state)) return null;
		if (isApprovalJourney(state) && continueApproverJourney(state)) return onContinue();
		return dispatch(goToPage(pages.EffectiveWarning.warning));
	});

export const goToEWWarning = (payType, onContinue) => (dispatch, getState) => {
	const state = getState();

	if (isSMEUser(state) && isStaticWarning(state, payType)) {
		return dispatch(generateRetrievalId()).then((response) => {
			if (response.type === GENERATE_RETRIEVAL_ID_SUCCESS) getEWOutcome(getState, dispatch, onContinue, payType);
		});
	}
	return getEWOutcome(getState, dispatch, onContinue, payType);
};

export const updateOutcomeAcknowledgement =
	({ acknowledgement, payType }) =>
	(dispatch, getState) => {
		const state = getState();

		const { fromAccount, userId, effectiveWarningId, customerType, paymentDetails, isStatic, outcomeType } =
			getCommonData(state, payType);

		const endpoint = isStatic ? endpoints.updateOutcomeAcknowledgementStatic : endpoints.updateOutcomeAcknowledgement;

		const { x_bpi_version, method, uri } = endpoint;

		const urlData = {
			effectiveWarningId,
			customerType: capitalize(customerType),
			userId,
			fromAccount,
			acknowledgement,
			paymentDetails,
			isStaticWarning: isStatic,
			outcomeType,
			isBatch: isBatch(state),
			batchId: getBatchId(state),
		};

		const body = createOutcomeAcknowledgementRequest(urlData);
		const action = {
			[RSAA]: {
				endpoint: uri,
				method,
				types: [UPDATE_OUTCOME_ACK_REQUEST, UPDATE_OUTCOME_ACK_SUCCESS, UPDATE_OUTCOME_ACK_FAILURE],
				body,
				headers: { 'x-bpi-version': x_bpi_version },
			},
		};

		return dispatch(action);
	};

export const updateAdditionalPaymentGuidance =
	({ payType }) =>
	(dispatch, getState) => {
		const state = getState();

		const { fromAccount, userId, effectiveWarningId, customerType, isSMEUser, paymentDetails, isStatic } =
			getCommonData(state, payType);

		const endpoint = isStatic
			? endpoints.updateAdditionalPaymentGuidanceStatic
			: endpoints.updateAdditionalPaymentGuidance;
		const { x_bpi_version, method, uri } = endpoint;

		const urlData = {
			effectiveWarningId,
			fromAccount,
			userId,
			customerType: capitalize(customerType),
			isSMEUser,
			isStaticWarning: isStatic,
			paymentDetails,
			isBatch: isBatch(state),
			batchId: getBatchId(state),
		};

		const body = createAdditionalPaymentGuidanceRequest(urlData);
		const action = {
			[RSAA]: {
				endpoint: uri,
				method,
				types: [
					UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_REQUEST,
					UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_SUCCESS,
					UPDATE_ADDITIONAL_PAYMENT_GUIDANCE_FAILURE,
				],
				body,
				headers: { 'x-bpi-version': x_bpi_version },
			},
		};

		return dispatch(action);
	};
